import { Box, BoxProps } from '@mui/joy';

type LogoutFormProps = BoxProps;

export function LogoutForm(props: LogoutFormProps) {
  return <Box component="form" action="/api/authentication/logout" method="POST" {...props} />;
}
